import { Box } from '@mui/material';
import { SecurityInventoryCategory } from '@x-guard/xgac-types/xgac';
import { useState } from 'react';
import { useTranslate } from 'react-admin';
import TuneIcon from '@mui/icons-material/Tune';
import { InventoryItemFilter } from '../util';
import { InventoryItemFilters } from './InventoryItemFilters';

export const FilterButton = (props: {
  children: React.ReactNode;
  categories: SecurityInventoryCategory[];
  filters: InventoryItemFilter;
  onChange: (filters: InventoryItemFilter) => void;
}) => {

  const translate = useTranslate();
  const [filterOpen, setFilterOpen] = useState(false);

  const hasFilters = props.filters.categories.length > 0 || props.filters.status.length > 0;

  return (
    <Box sx={{
      position: 'relative',
      width: '100%',
    }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
        {/* This ensures that the search bar and filter are in the same row, but
        when the filter is opened its pop-up is full-width */}
        <Box sx={{ flex: '1 1 60%', minWidth: 0 }}>
          {props.children}
        </Box>
        <Box sx={{ flex: '0 0 40%', minWidth: 0 }}>
          <button
            type="button"
            className={hasFilters ? 'filter-items-button filter-items-button-active' : 'filter-items-button'}
            onMouseDown={(event) => event.stopPropagation()}
            onClick={() => setFilterOpen((open) => !open)}
          >
            <TuneIcon />
            <span>
              {translate(hasFilters ? 'general.text.filtered' : 'general.text.filter')}
            </span>
          </button>
        </Box>
      </Box>
      <InventoryItemFilters
        filters={props.filters}
        onChange={props.onChange}
        open={filterOpen}
        onOpenChange={setFilterOpen}
        categories={props.categories}
      />
    </Box>
  );

};
